import _styled13 from "styled-components";
import _styled12 from "styled-components";
import _styled11 from "styled-components";
import _styled10 from "styled-components";
import _styled9 from "styled-components";
import _styled8 from "styled-components";
import _styled7 from "styled-components";
import _styled6 from "styled-components";
import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
import React, { useState } from 'react';
import { BasisProvider, defaultTheme, Form, Select, Input, Text } from 'basis';
import { BREAKPOINT, COLOR } from '@latitude/core/utils/constants';
import { FramedContainer } from '@latitude/framed-container';
import ReactHTMLParser from 'react-html-parser';
var currency = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD'
});
var maxAmount = 30000;
export var InstalmentInterestFreeCalculatorSelectableMinimums = function InstalmentInterestFreeCalculatorSelectableMinimums(_ref) {
  var annualFee = _ref.annualFee,
      establishmentFee = _ref.establishmentFee,
      minimumAmount = _ref.minimumAmount,
      monthlyFee = _ref.monthlyFee,
      monthlyTerms = _ref.monthlyTerms,
      importantInfo = _ref.importantInfo,
      productName = _ref.productName,
      isGemVisa = _ref.isGemVisa,
      _ref$superscriptText = _ref.superscriptText,
      superscriptText = _ref$superscriptText === void 0 ? '' : _ref$superscriptText;
  var interestFreeOptions = monthlyTerms.map(function (term) {
    return {
      label: term + " Months",
      value: term.toString()
    };
  });

  var _useState = useState(minimumAmount),
      selectedMinimumAmount = _useState[0],
      setSelectedMinimumAmount = _useState[1];

  var paymentFrequencyOptions = [{
    label: 'Per month',
    value: '0',
    perYear: 12
  }, {
    label: 'Per week',
    value: '1',
    perYear: 52
  }, {
    label: 'Per day',
    value: '2',
    perYear: 365
  }];
  var initialValues = {
    interestFreePeriod: interestFreeOptions[0].value,
    purchaseAmount: minimumAmount.toString(),
    paymentFrequency: paymentFrequencyOptions[0].value,
    selectedMinimumAmount: minimumAmount.toString()
  };
  return /*#__PURE__*/React.createElement(BasisProvider, {
    theme: defaultTheme
  }, /*#__PURE__*/React.createElement(Form, {
    initialValues: initialValues
  }, function (_ref2) {
    var state = _ref2.state;
    var interestFreePeriod = parseInt(state.values.interestFreePeriod, 10);
    var purchaseAmount = parseFloat(state.values.purchaseAmount);
    var paymentFrequency = paymentFrequencyOptions[parseInt(state.values.paymentFrequency, 10)];
    var result;
    var total;

    if (purchaseAmount < selectedMinimumAmount) {
      //   $('.error').text('Interest free is only available on amounts of $' + minimum_amount + ' or more').slideDown();
      //   return "$0.00";
      result = 0;
      total = 0;
    } else {
      total = interestFreePeriod * monthlyFee + establishmentFee + purchaseAmount + annualFee * Math.round(interestFreePeriod / 12);
    }
    /**
     * Note — Gem Visa AU currently has an edge case requirement where monthly fee should not
     * include the monthly fee in the per monthly output, but should include it within the total amount paid output.
     * The below conditional will accommodate this scenario until it is no longer required.
     */


    if (isGemVisa) {
      if (purchaseAmount < selectedMinimumAmount || purchaseAmount > maxAmount) {
        result = 0;
      } else {
        result = purchaseAmount / interestFreePeriod * (12 / paymentFrequency.perYear);
      }
    } else {
      result = purchaseAmount / interestFreePeriod * (12 / paymentFrequency.perYear) + monthlyFee * (12 / paymentFrequency.perYear);
    }

    return /*#__PURE__*/React.createElement(_StyledDiv, {
      $_css: BREAKPOINT.XS,
      $_css2: BREAKPOINT.LG
    }, /*#__PURE__*/React.createElement(_StyledDiv2, null, /*#__PURE__*/React.createElement(Input, {
      name: "purchaseAmount",
      label: "Purchase amount",
      type: "text",
      variant: "numeric",
      helpText: "Min purchase " + currency.format(selectedMinimumAmount),
      validate: function validate(e) {
        if (!e) {
          return "Required";
        }

        if (isNaN(e)) {
          return "Only numbers are allowed";
        }

        if (e > maxAmount) {
          return "Purchase amount must not exceed $30,000";
        }

        return e >= selectedMinimumAmount ? null : "Purchase amount must be at least $" + parseFloat(selectedMinimumAmount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      }
    }), /*#__PURE__*/React.createElement(_StyledDiv3, {
      $_css3: BREAKPOINT.LG
    }, /*#__PURE__*/React.createElement(Select, {
      name: "paymentFrequency",
      label: "Payment frequency",
      options: paymentFrequencyOptions
    }))), /*#__PURE__*/React.createElement(FramedContainer, {
      theme: {
        contentBorderColor: COLOR.BLUE_SKY,
        frameColor: '#B1DBFF'
      }
    }, /*#__PURE__*/React.createElement(_StyledDiv4, {
      $_css4: COLOR.BLUE_SKY,
      $_css5: BREAKPOINT.XS,
      $_css6: BREAKPOINT.LG
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
      textStyle: "body1"
    }, /*#__PURE__*/React.createElement(_StyledStrong, {
      $_css7: BREAKPOINT.LG
    }, "Your " + interestFreePeriod + " month Interest Free payment plan")), result > 0 ? /*#__PURE__*/React.createElement(_StyledDiv5, null, /*#__PURE__*/React.createElement(Text, {
      textStyle: "body",
      color: "primary.blue.t100"
    }, "from"), /*#__PURE__*/React.createElement(Text, {
      textStyle: "heading3",
      color: "primary.blue.t100"
    }, /*#__PURE__*/React.createElement(_StyledSpan, {
      $_css8: BREAKPOINT.LG,
      $_css9: require('./images/sizzles-mobile-left.svg'),
      $_css10: BREAKPOINT.XS,
      $_css11: BREAKPOINT.LG,
      $_css12: require('./images/sizzles-desktop-left.svg'),
      $_css13: require('./images/sizzles-mobile-right.svg'),
      $_css14: BREAKPOINT.XS,
      $_css15: BREAKPOINT.LG,
      $_css16: require('./images/sizzles-desktop-right.svg')
    }, currency.format(result))), /*#__PURE__*/React.createElement(Text, {
      textStyle: "body",
      color: "primary.blue.t100"
    }, paymentFrequency.label.toLowerCase(), /*#__PURE__*/React.createElement("sup", null, "*"))) : /*#__PURE__*/React.createElement(_StyledText, null, /*#__PURE__*/React.createElement("br", null), "please enter a valid", /*#__PURE__*/React.createElement("br", null), "purchase amount", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Text, {
      textStyle: "body2"
    }, /*#__PURE__*/React.createElement("sup", null, "*"), annualFee > 0 && "Excludes $" + annualFee + " annual account fee. ", isGemVisa ? ReactHTMLParser("Instalment excludes $" + monthlyFee + " monthly credit card fee" + superscriptText + ".") : monthlyFee > 0 && ReactHTMLParser("Instalment includes a $" + monthlyFee + " monthly credit card fee" + superscriptText + "."), paymentFrequency.label !== 'Per month' && 'Monthly repayments required, exact amount specified in your statement.')), /*#__PURE__*/React.createElement(_StyledHr, {
      $_css17: COLOR.BLUE_LIGHT
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
      textStyle: "subtitle2",
      color: "primary.blue.t100"
    }, /*#__PURE__*/React.createElement(_StyledStrong2, null, "Total amount paid", /*#__PURE__*/React.createElement("sup", null, "^"))), result > 0 ? /*#__PURE__*/React.createElement(Text, {
      textStyle: "heading4",
      color: "primary.blue.t100"
    }, /*#__PURE__*/React.createElement(_StyledSpan2, {
      $_css18: BREAKPOINT.LG
    }, currency.format(total))) : '', /*#__PURE__*/React.createElement(Text, {
      textStyle: "body2"
    }, /*#__PURE__*/React.createElement(_StyledSpan3, null, /*#__PURE__*/React.createElement("sup", null, "^"), productName && productName + ": ", annualFee > 0 && "Includes a $" + annualFee + " annual account fee, charged after your first purchase\n                          and each anniversary date. ", isGemVisa ? ReactHTMLParser("Includes $" + monthlyFee + " monthly credit card fee" + superscriptText + ".") : monthlyFee > 0 && ReactHTMLParser("Includes a $" + monthlyFee + " monthly credit card fee" + superscriptText + "."), establishmentFee > 0 && "Add $" + establishmentFee + " once only establishment fee for new customers."))))));
  }), /*#__PURE__*/React.createElement(_StyledDiv6, {
    $_css19: BREAKPOINT.LG
  }, /*#__PURE__*/React.createElement(Text, {
    textStyle: "heading4",
    align: "center"
  }, "Important things to remember"), importantInfo ? importantInfo.map(function (line) {
    return /*#__PURE__*/React.createElement(Text, null, ReactHTMLParser(line));
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, null, "These repayments are for Equal monthly payment plans only and do not take into account any other purchases or balances."), establishmentFee > 0 && /*#__PURE__*/React.createElement(Text, null, "The instalment and total estimated price amounts exclude the one-off $", establishmentFee, " establishment fee payable by new customers."), /*#__PURE__*/React.createElement(Text, null, "The monthly, weekly and daily repayments are approximate only."), /*#__PURE__*/React.createElement(Text, null, "Monthly repayments are required, exact amount specified in the customer\u2019s statement."), /*#__PURE__*/React.createElement(Text, null, "Minimum financed amount applies. See current promotions for terms and conditions."), /*#__PURE__*/React.createElement(Text, null, "Effective from 29th March 2023, the monthly account service fee will increase to $9.95."), /*#__PURE__*/React.createElement(Text, null, "Various plans only available during specific promotional periods."))));
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledDiv",
  componentId: "sc-9vwtvs-0"
})(["> div{&:nth-child(2),&:last-child{margin-top:20px;text-align:center;}}@media (min-width:", "){display:flex;align-items:center;> div:first-child{width:42%;}> div:last-child{width:52%;@media (min-width:", "){width:45.5%;}}}"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledDiv2",
  componentId: "sc-9vwtvs-1"
})(["> div:not(:first-child){margin-top:20px;}"]);

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledDiv3",
  componentId: "sc-9vwtvs-2"
})(["@media (min-width:", "){display:flex;justify-content:space-between;> div{width:48%;}}"], function (p) {
  return p.$_css3;
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledDiv4",
  componentId: "sc-9vwtvs-3"
})(["background:", ";padding:32px;@media (min-width:", "){padding:8px;}@media (min-width:", "){padding:16px 32px;}"], function (p) {
  return p.$_css4;
}, function (p) {
  return p.$_css5;
}, function (p) {
  return p.$_css6;
});

var _StyledStrong = /*#__PURE__*/_styled("strong").withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledStrong",
  componentId: "sc-9vwtvs-4"
})(["@media (min-width:", "){font-size:1.2em;}"], function (p) {
  return p.$_css7;
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledDiv5",
  componentId: "sc-9vwtvs-5"
})(["margin:8px 0;"]);

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledSpan",
  componentId: "sc-9vwtvs-6"
})(["@media (min-width:", "){font-size:1.5em;}&:before{content:'';position:absolute;top:57px;width:34px;height:81px;margin-left:-14px;background-image:url(", ");background-size:contain;@media (min-width:", "){top:35px;margin-left:-14px;}@media (min-width:", "){top:64px;height:60px;margin-left:-38px;background-image:url(", ");}}&:after{content:'';position:absolute;top:72px;width:26px;height:60px;margin-left:-14px;background-image:url(", ");background-size:contain;@media (min-width:", "){top:49px;margin-left:-12px;}@media (min-width:", "){top:65px;width:35px;height:52px;margin-left:4px;background-image:url(", ");}}"], function (p) {
  return p.$_css8;
}, function (p) {
  return p.$_css9;
}, function (p) {
  return p.$_css10;
}, function (p) {
  return p.$_css11;
}, function (p) {
  return p.$_css12;
}, function (p) {
  return p.$_css13;
}, function (p) {
  return p.$_css14;
}, function (p) {
  return p.$_css15;
}, function (p) {
  return p.$_css16;
});

var _StyledText = /*#__PURE__*/_styled(Text).withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledText",
  componentId: "sc-9vwtvs-7"
})(["margin:28px 0;color:#b3000c;"]);

var _StyledHr = /*#__PURE__*/_styled("hr").withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledHr",
  componentId: "sc-9vwtvs-8"
})(["border-top:2px solid ", ";"], function (p) {
  return p.$_css17;
});

var _StyledStrong2 = /*#__PURE__*/_styled("strong").withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledStrong2",
  componentId: "sc-9vwtvs-9"
})(["font-weight:400 !important;"]);

var _StyledSpan2 = /*#__PURE__*/_styled("span").withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledSpan2",
  componentId: "sc-9vwtvs-10"
})(["@media (min-width:", "){font-size:1.1em;}"], function (p) {
  return p.$_css18;
});

var _StyledSpan3 = /*#__PURE__*/_styled("span").withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledSpan3",
  componentId: "sc-9vwtvs-11"
})(["margin-top:8px;display:block;"]);

var _StyledDiv6 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "InstalmentInterestFreeCalculatorSelectableMinimums___StyledDiv6",
  componentId: "sc-9vwtvs-12"
})(["margin-top:20px;@media (min-width:", "){margin-top:40px;}> p{margin-bottom:20px;}"], function (p) {
  return p.$_css19;
});